import React, { useCallback, useContext, useState } from "react";
import { ViewportElement } from "@foundation/viewport-element";
import { QuoteContext } from "~context/QuoteContext";
import { RelatedNewsPlaceholder } from "~components/RelatedNews/RelatedNewsPlaceholder";
import { RelatedNews } from "~components/dynamic";

export default function RelatedNewsContainer() {
  const quoteData = useContext(QuoteContext);
  const [enteredRelatedNews, setEnteredRelatedNews] = useState(false);
  const [isDoneFetching, setIsDoneFetching] = useState(false);

  const onLoad = useCallback(() => setIsDoneFetching(true), []);

  if (!quoteData) {
    return null;
  }

  const { id, type } = quoteData;

  return (
    <ViewportElement
      onEnter={() => setEnteredRelatedNews(true)}
      rootMargin="400px"
    >
      {!isDoneFetching && <RelatedNewsPlaceholder />}
      {enteredRelatedNews && (
        <RelatedNews tickerId={id} securityType={type} onLoad={onLoad} />
      )}
    </ViewportElement>
  );
}
